import React from 'react'
import { Heading, Body } from '@superhi/design'

import IntroComponent from 'src/components/sections/Intro'

const Intro: React.FC<React.PropsWithChildren<unknown>> = () => (
  <IntroComponent
    decorationName="star"
    decorationPosition="bottom-left"
    left={
      <Heading level="3" as={'p'}>
        We&rsquo;re an online education platform and worldwide community of creatives learning
        together.
      </Heading>
    }
    right={
      <Body level="2">
        Code, design and project management are skills that bring your creative visions to life, and
        that&rsquo;s exciting! Founded in 2016, SuperHi is a global community of people learning
        together online, with some of the best teachers on the planet (though we may be biased).
      </Body>
    }
    collapseBottomPadding
  />
)

export default Intro
